import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { Link } from 'foundations-components/transitional/components/Link';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import getSalesPhoneNumber from '../../common/adapters/getSalesPhoneNumber';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PHONE_NUMBERS_URL = 'https://www.hubspot.com/company/contact';
export const CallConfirmationSection = () => {
  const {
    phoneNumber: salesPhoneNumber,
    countryCode
  } = getSalesPhoneNumber();
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    "data-test-id": "communication-call-submit-success",
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.communicationMethods.callSuccess"
      })
    }), /*#__PURE__*/_jsx("h6", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.communicationMethods.localization.or"
      })
    }), /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.communicationMethods.localization.callNow"
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "h4",
      children: salesPhoneNumber
    }), countryCode && /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `SharedI18nStrings.countryCodes.${countryCode}`
      })
    }), /*#__PURE__*/_jsx(Text, {
      marginBlockStart: "800",
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(Link, {
        href: PHONE_NUMBERS_URL,
        external: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.localization.viewAllButton"
        })
      })
    })]
  });
};